import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as ProfileSelectors from 'app/modules/profile/selectors'
import ProfileSection from './Sections/Profile'
import { makeDefaultFailedContainer } from 'components/container'
import styles from './styles.styl'

class UserProfile extends Component {
  render() {
    const { user, ...rest } = this.props
    return (
      <div className={styles.UserProfile}>
        <ProfileSection user={user} {...rest} />
      </div>
    )
  }
}

const UserProfileContainer = makeDefaultFailedContainer(UserProfile, {
  listenTo: ['stores.UserStore', 'stores.UserPropertiesStore'],
  fetch: {
    user() {
      return this.app.stores.UserStore.getOrFetchCurrentUser()
    },
    userProperties() {
      return this.app.stores.UserPropertiesStore.fetchPropertiesForCurrentUser()
    },
  },
})

const mapStateToProps = state => ({
  profile: ProfileSelectors.profile(state),
  isProfileLoaded: ProfileSelectors.isLoaded(state),
})

export default connect(mapStateToProps, null)(UserProfileContainer)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/UserProfile/index.js